import { Observable, BehaviorSubject } from 'rxjs';
import { switchMap, pluck, map } from 'rxjs/operators';

import { Component, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';

import { SnLonLatLike } from '@lib/geo/helpers';

import { SnGoogleGeocoderService } from '../../services';

@Component({
  selector: 'sn-google-address-geocoder',
  styleUrls: ['./google-address-geocoder.component.scss'],
  template: '{{ address$ | async }}',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoogleAddressGeocoderComponent implements OnDestroy {
  @Input()
  set lonLat(lonLat: SnLonLatLike) {
    this._lonLat$.next(lonLat);
  }

  public readonly address$: Observable<string>;

  private _lonLat$ = new BehaviorSubject<SnLonLatLike>(null);

  constructor(geocoder: SnGoogleGeocoderService) {
    this.address$ = this._lonLat$.pipe(
      switchMap((lonLat) => geocoder.geocode({ lonLat })),
      map((results) => results[0]),
      pluck('formattedAddress'),
    );
  }

  public ngOnDestroy(): void {
    this._lonLat$.complete();
  }
}
